function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#67BBB0",
  d: "M0,80C0,35.816,35.817,0,80,0s80,35.816,80,80c0,44.183-35.817,80-80,80S0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M121.001,114.154H39c-1.519,0-2.75-1.231-2.75-2.75V58.245c0-1.519,1.231-2.75,2.75-2.75h82 c1.518,0,2.75,1.231,2.75,2.75v53.159C123.751,112.923,122.519,114.154,121.001,114.154 M41.75,108.654h76.5V60.995h-76.5V108.654z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M76.355,60.995c-0.704,0-1.408-0.269-1.944-0.806l-8.846-8.845H41.75v6.234c0,1.519-1.232,2.75-2.75,2.75 c-1.519,0-2.75-1.231-2.75-2.75v-8.984c0-1.519,1.231-2.75,2.75-2.75h27.705c0.729,0,1.428,0.29,1.944,0.806l9.65,9.65 c1.075,1.073,1.075,2.814,0,3.889C77.763,60.727,77.059,60.995,76.355,60.995"
});

var SvgCartellaAccent = function SvgCartellaAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.349 -0.104 161 161",
    enableBackground: "new -0.349 -0.104 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCartellaAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cartella_accent.91e1fd27.svg";
export { ForwardRef as ReactComponent };